import { useList, CrudFilter } from '@refinedev/core';

import { UnifiedMitigation } from './../types';

export const useUnifiedMitigations = (show_mitigations: boolean, show_detection_rules: boolean) => {
  const filters: CrudFilter[] = [];

  if (show_mitigations && !show_detection_rules) {
    filters.push({ field: 'unifiedmitigationtype_in', operator: 'eq', value: '4,5' });
  } else if (show_detection_rules && !show_mitigations) {
    filters.push({ field: 'unifiedmitigationtype_not_in', operator: 'eq', value: '4,5' });
  }

  const migratedMitigationsQuery = useList<UnifiedMitigation>({
    resource: 'unified_mitigations',
    pagination: { pageSize: 10000 },
    filters
  });

  const mitigationsQuery = {
    ...migratedMitigationsQuery.result,
    ...migratedMitigationsQuery.query,
    ...migratedMitigationsQuery
  };

  return { mitigationsQuery };
};
